/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export var CourseTypeEnum = /*#__PURE__*/function (CourseTypeEnum) {
  CourseTypeEnum["B2B"] = "B2B";
  CourseTypeEnum["B2B_CLASSROOMS"] = "B2B_CLASSROOMS";
  CourseTypeEnum["DEGREE"] = "DEGREE";
  CourseTypeEnum["FREE"] = "FREE";
  CourseTypeEnum["FREEMIUM"] = "FREEMIUM";
  CourseTypeEnum["HIDDEN"] = "HIDDEN";
  CourseTypeEnum["MEMBERSHIP"] = "MEMBERSHIP";
  CourseTypeEnum["PAID"] = "PAID";
  CourseTypeEnum["PARTNER"] = "PARTNER";
  CourseTypeEnum["ROCKSTAR"] = "ROCKSTAR";
  CourseTypeEnum["TEMPORAL_ACCESS"] = "TEMPORAL_ACCESS";
  return CourseTypeEnum;
}({});
export var EnrollmentCourseQuizStatusEnum = /*#__PURE__*/function (EnrollmentCourseQuizStatusEnum) {
  EnrollmentCourseQuizStatusEnum["APPROVED"] = "APPROVED";
  EnrollmentCourseQuizStatusEnum["CERTIFICATE"] = "CERTIFICATE";
  EnrollmentCourseQuizStatusEnum["DISAPPROVED"] = "DISAPPROVED";
  EnrollmentCourseQuizStatusEnum["INCOMPLETE"] = "INCOMPLETE";
  EnrollmentCourseQuizStatusEnum["INITIAL"] = "INITIAL";
  EnrollmentCourseQuizStatusEnum["PROGRESS"] = "PROGRESS";
  return EnrollmentCourseQuizStatusEnum;
}({});
export var EnrollmentTypeEnum = /*#__PURE__*/function (EnrollmentTypeEnum) {
  EnrollmentTypeEnum["ENROLLMENT_B2B"] = "ENROLLMENT_B2B";
  EnrollmentTypeEnum["ENROLLMENT_DEGREE"] = "ENROLLMENT_DEGREE";
  EnrollmentTypeEnum["ENROLLMENT_FREE"] = "ENROLLMENT_FREE";
  EnrollmentTypeEnum["ENROLLMENT_FREEMIUM"] = "ENROLLMENT_FREEMIUM";
  EnrollmentTypeEnum["ENROLLMENT_FREE_MEMBERSHIP"] = "ENROLLMENT_FREE_MEMBERSHIP";
  EnrollmentTypeEnum["ENROLLMENT_GITCARD"] = "ENROLLMENT_GITCARD";
  EnrollmentTypeEnum["ENROLLMENT_MEMBERSHIP"] = "ENROLLMENT_MEMBERSHIP";
  EnrollmentTypeEnum["ENROLLMENT_MENTOR"] = "ENROLLMENT_MENTOR";
  EnrollmentTypeEnum["ENROLLMENT_PAID"] = "ENROLLMENT_PAID";
  EnrollmentTypeEnum["ENROLLMENT_PROFESSOR"] = "ENROLLMENT_PROFESSOR";
  EnrollmentTypeEnum["ENROLLMENT_STAFF"] = "ENROLLMENT_STAFF";
  EnrollmentTypeEnum["ENROLLMENT_TEMPORAL_ACCESS"] = "ENROLLMENT_TEMPORAL_ACCESS";
  return EnrollmentTypeEnum;
}({});
export var StatusProjectEnum = /*#__PURE__*/function (StatusProjectEnum) {
  StatusProjectEnum["CERTIFIED"] = "CERTIFIED";
  StatusProjectEnum["DRAFT"] = "DRAFT";
  StatusProjectEnum["FINISHED"] = "FINISHED";
  StatusProjectEnum["OBSERVED"] = "OBSERVED";
  StatusProjectEnum["PUBLISHED"] = "PUBLISHED";
  return StatusProjectEnum;
}({});
export var SubtitleEnum = /*#__PURE__*/function (SubtitleEnum) {
  SubtitleEnum["EN"] = "EN";
  SubtitleEnum["ES"] = "ES";
  SubtitleEnum["PT"] = "PT";
  return SubtitleEnum;
}({});

//==============================================================
// END Enums and Input Objects
//==============================================================